import { useInject } from 'dependable-react';
import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import { APP_DATA_TOKEN } from '../services/InjectTokens';
import { Page } from '../state/models';

export function useMobileBackgrounds(pages: Array<Page>) {
  const appData = useInject(APP_DATA_TOKEN);

  return useMemo(() => {
    const pagesNew = [
      ...pages.map((page: Page, index: number) => ({
        background: page.backgrounds.shared
          ? page.backgrounds.shared.smallUrl
          : page.backgrounds[appData.currentLanguage].smallUrl,
        page: index,
        ...(index === 0 ? { isCoverFront: true } : {}),
      })),
      {
        background: pages[0].backgrounds.shared
          ? pages[0].backgrounds.shared.smallUrl
          : pages[0].backgrounds[appData.currentLanguage].smallUrl,
        page: pages.length,
        isCoverBack: true,
      },
    ];

    if (appData.banner.showBannerIcon) {
      pagesNew.shift();
      pagesNew.pop();
    }

    return pagesNew;
  }, [appData.currentLanguage]);
}

export function useBackgrounds(pages: Array<Page>) {
  const appData = useInject(APP_DATA_TOKEN);

  const backgrounds = useMemo(() => {
    let pagesNew = [
      // We have to remove a natural order of pages because we generate empty pages
      // This will have to be refactored once empty pages are generated on CMS
      // At this moment, there is no way to add empty pages on CMS without adding them to the PDF print process
      // This is very hacky, but something we had to settle for at the moment
      // Sincerely,
      // fly
      ...pages
        .filter((_, index: number) => index !== pages.length - 1)
        .map((page: Page, index: number) => ({
          background: page.backgrounds.shared
            ? page.backgrounds.shared.smallUrl
            : page.backgrounds[appData.currentLanguage].smallUrl,
          contentId: index,
          pageNumber: index,
          ...(index === 0 ? { isCoverFront: true } : {}),
        })),
      {
        background: pages[0].backgrounds.shared
          ? pages[0].backgrounds.shared.smallUrl
          : pages[0].backgrounds[appData.currentLanguage].smallUrl,
        page: pages.length,
        isCoverBack: true,
      },
    ];

    if (appData.banner.showBannerIcon) {
      pagesNew.shift();
      pagesNew.pop();

      pagesNew = pagesNew.filter((page) => page.background !== undefined && page.background !== '');
    }
    //Makni predlist i zalist

    return pagesNew;
  }, [appData.currentLanguage]);

  return useMemo(() => {
    // This will also be part of a refactor
    let temp = [
      ...backgrounds,
      appData.banner.showBannerIcon === false && {
        background: '',
        contentId: null,
        pageNumber: 0.5,
      },
      appData.banner.showBannerIcon === false && {
        background: '',
        contentId: null,
        pageNumber: pages.length - 1,
      },
      {
        background: pages[pages.length - 1].backgrounds.shared
          ? pages[pages.length - 1].backgrounds.shared.smallUrl
          : pages[pages.length - 1].backgrounds[appData.currentLanguage].smallUrl,
        contentId: pages.length - 1,
        pageNumber: pages.length - 1.5,
        prijePrazne: true,
      },
    ];

    temp = temp.filter((item) => item !== false);

    return sortBy(temp, 'pageNumber');
  }, [backgrounds]);
}
